var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "route"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.58317 4.1665H9.94517C12.4845 4.1665 13.7542 4.1665 14.2362 4.62258C14.6528 5.01681 14.8375 5.59757 14.725 6.16001C14.5948 6.81068 13.5583 7.54388 11.4851 9.01028L8.09794 11.4061C6.02476 12.8725 4.98816 13.6057 4.85803 14.2563C4.74555 14.8188 4.93018 15.3995 5.34681 15.7938C5.82878 16.2498 7.09847 16.2498 9.63784 16.2498H10.4165M6.6665 4.1665C6.6665 5.54722 5.54722 6.6665 4.1665 6.6665C2.78579 6.6665 1.6665 5.54722 1.6665 4.1665C1.6665 2.78579 2.78579 1.6665 4.1665 1.6665C5.54722 1.6665 6.6665 2.78579 6.6665 4.1665ZM18.3332 15.8332C18.3332 17.2139 17.2139 18.3332 15.8332 18.3332C14.4525 18.3332 13.3332 17.2139 13.3332 15.8332C13.3332 14.4525 14.4525 13.3332 15.8332 13.3332C17.2139 13.3332 18.3332 14.4525 18.3332 15.8332Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.e2d0ef7431fd02858a255d45993a9f38.svg";
export { ForwardRef as ReactComponent };